import { request } from '@pb/utils'

export const fetchNotifications = async (): Promise<any> => {
  const { data } = await request.get('notification/alerts')
  return data
}

export const markNotificationsAsRead = async (notificationsIds): Promise<any> => {
  const notificatonsIdsArray = Array.isArray(notificationsIds)
    ? [...notificationsIds]
    : [notificationsIds]

  const { data } = await request.post('notification/read', {
    data: notificatonsIdsArray,
  })
  return data
}
